import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import WhiplashOauthCredentialsStore from "../../../stores/credentials/whiplash-credentials-store";

interface IIntegrationProps {
    credentialsStore: WhiplashOauthCredentialsStore,
    vGroup: IValidationGroup,
}

const WhiplashCredentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {
    return (
        <>
            <FormFieldLine label='Customer ID' required key='customer_id' note='Whiplash customer ID'>
                <Input
                    value={credentialsStore.customerId}
                    onChange={v => credentialsStore.customerId = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='Warehouse ID' required key='warehouse_id' note='Whiplash warehouse ID'>
                <Input
                    value={credentialsStore.warehouseId}
                    onChange={v => credentialsStore.warehouseId = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='Client ID' required key='client_id' note='Whiplash client ID'>
                <Input
                    value={credentialsStore.clientId}
                    onChange={v => credentialsStore.clientId = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='Client secret' required key='client_secret' note='Whiplash client secret'>
                <Input
                    value={credentialsStore.clientSecret}
                    onChange={v => credentialsStore.clientSecret = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine label='User ID' required key='user_id' note='Whiplash user ID'>
                <Input
                    value={credentialsStore.userId}
                    onChange={v => credentialsStore.userId = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
        </>
    )
});

export default WhiplashCredentials;
